import { render } from "./RiProdoffering266.vue?vue&type=template&id=07b83d90"
import script from "./RiProdoffering266.vue?vue&type=script&lang=js"
export * from "./RiProdoffering266.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiProdoffering266.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "07b83d90"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('07b83d90', __exports__)) {
    api.reload('07b83d90', __exports__)
  }
  
  module.hot.accept("./RiProdoffering266.vue?vue&type=template&id=07b83d90", () => {
    api.rerender('07b83d90', render)
  })

}


export default __exports__